export function isRunningInStorybook() {
    try {
        if (process.env.STORYBOOK) return true
    } catch {
        // ReferenceError will be thrown if process is undefined
    }

    return false
}
